import { Injectable } from '@angular/core';
import { SaveInfoSearchService } from '../../http/web/saveInfoSearch.service';

@Injectable()
export class saveDataSearchUtil {
  constructor(
    private saveSearchServ: SaveInfoSearchService
  ) {}
  public saveData(secction, key, value) {
    // this.saveSearchServ.saveinfo(secction, key, value).subscribe();
  }
}
